<script setup lang="ts">
import { CHART_ENGINE } from '@/shared/lib'

import AmChartsLineChart from './AmChartsLineChart.vue'
import ChartJsLineChart from './ChartJsLineChart.vue'
import type { LineChartProps } from './types'

/**
 * Several metrics over time, on a **date** axis: pass the rows and one `series` entry
 * per line.
 *
 * `ColumnChart` and not this for a single value per bucket — this one spaces its points by
 * how far apart their dates actually are, which is what makes a trend readable and a
 * single-day report nearly empty. Every line gets a value axis in its own colour, so
 * impressions and CPM stay readable side by side.
 *
 * Up to five lines: the palette is that long, and a sixth would repeat a colour.
 *
 * Drawn by Chart.js or amCharts, whichever `CHART_ENGINE` names; until one of them goes, a
 * change of behaviour is made in both `ChartJsLineChart.vue` and `AmChartsLineChart.vue`.
 */
defineProps<LineChartProps>()

const engine =
  CHART_ENGINE === 'amcharts' ? AmChartsLineChart : ChartJsLineChart
</script>

<template>
  <component :is="engine" v-bind="$props" />
</template>
